export default __webpack_public_path__ + "static/media/take-selfie-example-3.a9d3673f.png";